import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

// istanbul ignore next
export function getBrowserHistory() {
  return history;
}
